<template>

  <h3 class="profile-info">
    <span v-if="contactItem.company">{{ contactItem.company }} -</span> 
    <span v-if="contactItem.unit">{{ contactItem.unit }}</span> 
    <span v-if="contactItem.country">({{ contactItem.country }})</span>
  </h3>
  
  <p v-if="contactItem.role" class="font-bold">{{ contactItem.role }}</p>
  
  <hr>
  
  <p v-if="contactItem.telephone">
    mobile: <a :href="'tel:'+ contactItem.telephone">{{ contactItem.telephone }}</a> 
  </p>
  
  <p v-if="contactItem.email">
    email: <a :href="'mailto:'+ contactItem.email">{{ contactItem.email }}</a> 
  </p>
  
</template>

<script>
export default {
  name: 'ContactInfo',
  props: ['contactItem']
}
</script>

<style>
</style>

<style scoped>
</style>
